import styled from "@emotion/styled";
import { Grid, Stack, Typography } from "@mui/material";
import { deepPurple, grey } from "@mui/material/colors";
import { Box } from "@mui/system";

export const DropzoneContainer = styled(Box)(() => ({
  margin: "1rem",
}));

export const Dropzone = styled(Box)(() => ({
  width: "160px",
  height: "160px",
  padding: "1rem",
  marginBottom: "0.5rem",
  backgroundColor: grey[50],
  border: "2px dashed " + grey[400],
  borderRadius: "10px",
  color: grey[800],
  transition: "border-color 143ms linear",
  boxSizing: "border-box",
  "&: hover": {
    borderColor: "#0d0d0d",
    cursor: "pointer",
  },
}));

export const LargeDropzone = styled(Box)(() => ({
  width: "314px",
  height: "234px",
  padding: "1rem",
  marginBottom: "0.5rem",
  backgroundColor: grey[50],
  border: "2px dashed " + grey[400],
  borderRadius: "10px",
  color: grey[800],
  transition: "border-color 143ms linear",
  boxSizing: "border-box",
  "&: hover": {
    borderColor: deepPurple[400],
    cursor: "pointer",
  },
}));

export const DropzoneContent = styled(Box)(() => ({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  wordBreak: "break-word",
}));

export const FileLabel = styled("p")(() => ({
  margin: 0,
  textAlign: "center",
  fontWeight: 600,
}));

export const FileHelper = styled("p")(() => ({
  margin: 0,
  paddingTop: "0.625rem",
  fontSize: "0.75rem",
  color: grey[600],
  textAlign: "center",
  wordBreak: "break-all",
}));

export const RequiredFileContainer = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  borderRadius: "8px",
  backgroundColor: "white",
  padding: "1rem",
}));

export const Section = styled(Box)(() => ({}));

export const FieldsGrid = styled(Grid)(() => ({
  borderRadius: "8px",
  backgroundColor: "white",
  padding: "1rem 2rem"
}));

export const TypeDescription = styled("p")(() => ({
  margin: 0,
}));

export const TreatmentType = styled(Typography)(() => ({
  fontSize: "20px",
  fontWeight: 600,
}));
